import LoadingComponent from "./Loading.vue";
export default {
  install: function (Vue) {
    Vue.component("loading", LoadingComponent)
  }
}


// WEBPACK FOOTER //
// ./src/components/loading/index.js